/**
 * Same ZP-ENQ-style format as enquiryReference.ts's generateEnquiryReference,
 * kept as its own file (rather than a shared helper) because orders and
 * enquiries are different domains that happen to share a shape today —
 * matching this repo's existing precedent of separate *Enquiry.ts files with
 * identical internal logic. An 8-digit suffix (100M/year), not 5 (100k/year)
 * — this reference is also the Firestore doc ID (see writeOrder in
 * firebaseClient.ts), and a 5-digit keyspace hits a 50% collision chance by
 * the birthday paradox at only ~372 orders/year, with no App Check or rate
 * limiting on this project to slow down brute-force enumeration of an
 * `allow get: if true` collection either (see firestore.rules). 8 digits
 * pushes the 50% collision point past 11,000 orders/year and makes
 * enumerating the full keyspace impractical under Spark's free read quota.
 * writeOrder() still retries once on a residual collision — this narrows
 * the risk, it doesn't eliminate the need for that retry.
 */
export function generateOrderReference(): string {
  const year = new Date().getFullYear();
  const suffix = Math.floor(Math.random() * 100000000)
    .toString()
    .padStart(8, "0");
  return `ZP-ORD-${year}-${suffix}`;
}
